const SET_REGULATIONTYPE = 'setRegulationType'
const SET_REGULATIONTYPES = 'setRegulationTypes'

export const mutationTypes = {
  SET_REGULATIONTYPE,
  SET_REGULATIONTYPES
}

export const mutations = {
  [SET_REGULATIONTYPE] (state, payload) {
    state.regulationtype = payload
  },

  [SET_REGULATIONTYPES] (state, payload) {
    state.regulationtypes = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/regulationtype/mutations.js